import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "ag-grid-checkbox-renderer",
  template: `<input type="checkbox" (click)="checkedHandler($event)" [checked]="params.value" /> `,
  standalone: false,
})
export class CheckboxRenderer implements ICellRendererAngularComp {
  public params: any;

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  agInit(params: any): void {
    this.params = params;
  }

  checkedHandler(event) {
    return false;
  }
}
